import React from 'react';
import { connect } from 'react-redux';
import { map, isEmpty, orderBy } from 'lodash';

import {
    DISPLAY_STEP,
    STATE_PENDING,
    STATE_VALID,
    STATE_INVALID,
    DEFAULT_FILTER_VALUE
} from '../../../../constants/payment';
import SvgComponent from '../../../SvgComponent';

import { toDate } from '../../../../utils/dateUtils';
import { formatAmount } from '../../../../utils/index';
import { fetchFaqIfNeeded } from '../../../../services/faq/actions';
import ButtonComponent from '../../../../components/button/ButtonComponent';
import { MOMENTJS_DATE_FORMAT_STANDARD } from '../../../../constants/moment';
import CashbackHistoryLegendComponent from './CashbackHistoryLegendComponent';
import { STATIC_ROOT, MY_POT_MOST_COMMON_QUESTIONS } from '../../../../constants';
import FaqElementComponent from '../../../../components/pages/faq/FaqElementComponent';
import { fetchAccountPurchasesIfNeeded } from '../../../../services/account/cashback/actions';

const stateList = [DEFAULT_FILTER_VALUE, STATE_PENDING, STATE_VALID, STATE_INVALID];

const renderPurchaseState = (icon, text, height, width) => (
    <td className="enteteTdTableBas">
        <SvgComponent
            src={`${STATIC_ROOT}/compte/mes-achats/${icon}.svg`}
            width={width}
            height={height}
        />
        <span className="hidden-mobonly inbl stateTxt">{text}</span>
    </td>
);

class CashbackHistoryComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            index: DISPLAY_STEP,
            filters: [-1],
            sortColumn: '',
            sortType: false
        };
    }

    handleSeeMoreClick() {
        this.setState({
            index: this.state.index + DISPLAY_STEP
        });
    }

    componentDidMount() {
        this.props.fetchAccountPurchasesIfNeeded();
        this.props.fetchFaqIfNeeded();
    }

    renderConditionnalOnPurchaseState(purchaseState, paymentDate) {
        if (!purchaseState) return null;
        const i18n = this.props.i18n;
        if (purchaseState === STATE_VALID && paymentDate > 0) {
            return renderPurchaseState('paye', i18n.PAID, 20, 20);
        } else if (purchaseState === STATE_VALID) {
            return renderPurchaseState('valide', i18n.VALID, 20, 20);
        } else if (purchaseState === STATE_PENDING) {
            return renderPurchaseState('attente', i18n.WAITING, 20, 20);
        } else if (purchaseState === STATE_INVALID) {
            return renderPurchaseState('invalide', i18n.INVALID, 20, 20);
        }
    }

    getLabel = stateId => {
        const i18n = this.props.i18n;

        if (stateId === STATE_VALID) {
            return i18n.VALID;
        } else if (stateId === STATE_PENDING) {
            return i18n.WAITING;
        } else if (stateId === STATE_INVALID) {
            return i18n.INVALID;
        } else {
            return i18n.ALL;
        }
    };

    renderSeeMoreButton(length, index, text, color) {
        if (length >= DISPLAY_STEP && index < length) {
            return (
                <div id="bt-voir-plusgains" className="txtcenter">
                    <ButtonComponent
                        type="button"
                        text={text}
                        color={color}
                        onClick={this.handleSeeMoreClick.bind(this)}
                    />
                </div>
            );
        }
    }

    onChangeFilter = e => {
        const { value } = e.target;
        const { filters } = this.state;

        let newFilters;

        if (filters.includes(Number(value))) {
            newFilters = filters.filter(i => i !== Number(value));
        } else {
            newFilters = [...filters.filter(i => i !== DEFAULT_FILTER_VALUE), Number(value)];
        }

        if (Number(value) === DEFAULT_FILTER_VALUE || !newFilters.length) {
            newFilters = [DEFAULT_FILTER_VALUE];
        }

        this.setState({ filters: newFilters });
    };

    onChangeSort = key => {
        this.setState({
            sortColumn: key,
            sortType: this.state.sortColumn !== key ? true : !this.state.sortType
        });
    };

    showSortArrow = columnName => {
        const { sortColumn, sortType } = this.state;

        if (sortColumn === columnName) {
            if (sortType) {
                return 'desc';
            } else {
                return 'asc';
            }
        }

        return '';
    };

    render() {
        const { data, i18n, faqData } = this.props;
        const { filters, sortColumn, sortType } = this.state;

        const theme = faqData.find(e => !isEmpty(e.faqs)) || null;

        const purchases = orderBy(
            (data || []).filter(
                purchase => filters.includes(purchase.state) || filters.includes(-1)
            ),
            [sortColumn],
            [sortType ? 'desc' : 'asc']
        );

        return (
            <div className="historiqueAchat">
                <h3>{i18n.PURCHASE_HISTORY}</h3>

                <div class="filters">
                    <div className="filterLabel">{i18n.FILTERS_LABEL}</div>
                    {stateList.map(state => (
                        <div className="filter" key={state}>
                            <input
                                type="checkbox"
                                name={`filter${state}`}
                                id={`filter${state}`}
                                value={state}
                                checked={filters.includes(state)}
                                onChange={this.onChangeFilter}
                            />
                            <label htmlFor={`filter${state}`}>{this.getLabel(state)}</label>
                        </div>
                    ))}
                </div>

                <table className="table" id="historique-achat-table">
                    <thead>
                        <tr>
                            <th
                                className={`dateTh sortTh ${this.showSortArrow('purchaseDate')}`}
                                onClick={() => this.onChangeSort('purchaseDate')}>
                                {i18n.TH_DATE}
                                <span className="arrow" />
                            </th>
                            <th
                                className={`marchandTh sortTh ${this.showSortArrow('partnerName')}`}
                                onClick={() => this.onChangeSort('partnerName')}>
                                {i18n.TH_MARCHAND}
                                <span className="arrow" />
                            </th>
                            <th
                                className={`opacite enteteTdTableBas gainsTh sortTh ${this.showSortArrow(
                                    'gain'
                                )}`}
                                onClick={() => this.onChangeSort('gain')}>
                                {i18n.TH_GAINS}
                                <span className="arrow" />
                            </th>
                            <th>
                                <span className="hidden-mobonly">{i18n.TH_ETAT}</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {purchases.length > 0 ? (
                            map(purchases.slice(0, this.state.index), purchase => (
                                <tr key={purchase.id}>
                                    <td className="enteteTdTableBas">
                                        {toDate(
                                            purchase.purchaseDate,
                                            MOMENTJS_DATE_FORMAT_STANDARD
                                        )}
                                    </td>
                                    <td className="enteteTdTableBas">{purchase.partnerName}</td>
                                    <td className="enteteTdTableBas opacite">
                                        {formatAmount(purchase.gain)}
                                    </td>
                                    {this.renderConditionnalOnPurchaseState(
                                        purchase.state,
                                        purchase.paymentDate
                                    )}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td className="noGain" colspan="4">
                                    {i18n.NO_GAIN}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                {this.renderSeeMoreButton(
                    purchases.length,
                    this.state.index,
                    i18n.SEE_MORE_GAIN,
                    'main'
                )}

                <CashbackHistoryLegendComponent />

                <hr />
                <div className="faq-container inbl">
                    <div className="faq-bandeau">{i18n.FAQ.BLOC_TITLE}</div>
                    <div className="faq-list-container">
                        {theme &&
                            theme.faqs
                                .filter(faq => MY_POT_MOST_COMMON_QUESTIONS.includes(faq.id))
                                .map(faq => (
                                    <FaqElementComponent
                                        key={faq.id}
                                        faq={faq}
                                        cssClass="question-my-pot"
                                        forceArrowRight
                                        linkToFaqPage
                                    />
                                ))}
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        i18n: state.i18n.page.ACCOUNT.CASHBACK_JACKPOT,
        data: state.account.mycashback.purchases || [],
        faqData: state.faq.faqs || []
    };
}

const mapDispatchToProps = {
    fetchAccountPurchasesIfNeeded,
    fetchFaqIfNeeded
};

export default connect(mapStateToProps, mapDispatchToProps)(CashbackHistoryComponent);



// WEBPACK FOOTER //
// ./src/components/pages/account/cashback/CashbackHistoryComponent.js